module.exports = __webpack_public_path__ + "static/media/yoga_icon.9e0e9545.svg";